






import { defineComponent, reactive, toRefs, onMounted } from '@vue/composition-api';
import AlertArea from "../../components/AlertArea.vue";
import http from "../../plugins/http";
import * as Common from "../../commons/common";

export interface Data {
  errors: string[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(prop, context){

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      errors: new Array<string>(),
    });

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {

      if(context.root.$route.query.confirm_login == "true" && !window.confirm("現在ログイン中のユーザの処理が中断されます。本当によろしいですか？")){
        context.root.$router.push("/").catch(err => {});
        return;
      }

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/classroom_sessions/teacher_login`, {token: context.root.$route.query.t}).then(response => {

        if (context.root.$route.query.hasOwnProperty("credentials")) {
          context.root.$store.commit("setGauthCredentials", context.root.$route.query.credentials);
        }
        
        // トークン設定
        var token = response.data.user.access_token
        document.cookie = 'access_token=' + token;
        document.cookie = 'smarky_user_id=' + response.data.user.id;

        context.root.$store.commit("setCurrentUser", response.data.user);
        context.root.$store.commit("setSchools", response.data.schools);
        context.root.$store.commit("setCurriculums", response.data.curriculums);
        context.root.$store.commit("setViewPoints", response.data.view_points);
        context.root.$store.commit("setDefaultSheetType", response.data.default_sheet_type);
        
        if(response.data.user.role == Common.RoleEnum.EntranceTeacher1 || response.data.user.role == Common.RoleEnum.EntranceTeacher2){
          if(context.root.$store.getters.isOptionEntranceActive && context.root.$store.getters.isOptionPracticeActive){
            context.root.$router.push('/teacher_site/entrance_sheet_list').catch(() => {});
          }else if(context.root.$store.getters.isOptionEntranceActive){
            context.root.$router.push('/teacher_site/entrance_sheet_list').catch(() => {});
          }else if(context.root.$store.getters.isOptionPracticeActive){
            context.root.$router.push('/teacher_site/practice_sheet_list').catch(() => {});
          }else{
            context.root.$router.push("/?error_kind=entrance_option_not_active").catch(err => {});
          }
        }else{
          // 入試ユーザ以外のログインはデフォルトの試験一覧へ
          if(response.data.default_sheet_type == Common.SheetTypeEnum.Entrance){
            context.root.$router.push('/teacher_site/entrance_sheet_list').catch(() => {});
          }else if(response.data.default_sheet_type == Common.SheetTypeEnum.Cbt){
            context.root.$router.push('/teacher_site/cbt_sheet_list').catch(() => {});
          }else if(response.data.default_sheet_type == Common.SheetTypeEnum.Practice){
            context.root.$router.push('/teacher_site/practice_sheet_list').catch(() => {});
          }else{
            context.root.$router.push('/teacher_site/sheet_list').catch(() => {});
          }
        }
      })
      .catch(error=>{
        // エラーの場合はログイン画面に戻る
        context.root.$router.push(`/?error_kind=${error.response.data.error_kind}`).catch(err => {});
      });
      context.root.$store.dispatch("hideOverlay");
    });

    return {
      ...toRefs(state),
    }
  }
})
